<template #content>
    <Dialog :visible="visible" @update:visible="updateVisible" header="Usuário" @show="onShow" @hide="onHide"
        class="w-11 lg:w-4" modal>
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="nome" v-model="form.nome" class="w-full" />
                        <label for="nome">Nome<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['nome'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="login" v-model="form.login" class="w-full" />
                        <label for="login">Login<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['login'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="email" v-model="form.email" class="w-full" />
                        <label for="email">E-mail<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['email'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <Select id="perfil_id" v-model="form.perfil_id" :options="perfilOpt" optionLabel="descricao"
                            optionValue="id" :showClear="true" class="w-full" />
                        <label for="perfil_id">Perfil<span v-if="!form.id" class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['perfil_id'] }}</div>
                </div>
                <div class="flex flex-row gap-2 field mt-4 items-center justify-center">
                    <Checkbox id="ativo" v-model="form.ativo" inputId="ativo" :value="form.ativo" binary />
                    <label for="ativo">Ativo</label>
                    <div class="text-xs text-red-500">{{ errors['ativo'] }}</div>
                </div>


            </div>

            <div class="flex justify-content-end gap-1">
                <Button type="submit" label="Salvar" severity="success" icon="pi pi-save" size="small"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Select from 'primevue/select';
import Checkbox from 'primevue/checkbox';

import Usuario from '@/service/usuario.js';
import Perfil from '@/service/perfil.js';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        Password,
        Button,
        Select,
        Checkbox,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
    },
    emits: ['save', 'close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
            perfilOpt: [],
            isLoadingPerfilOpt: false,
        }
    },
    methods: {
        onShow() {
            this.errors = {};
            this.form = { ...this.data, ativo: this.data.ativo === 1 };
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if (form.id) {
                return Usuario.update(form.id, form);
            }
            return Usuario.create(form);
        },
        loadPerfilOpt() {
            this.isLoadingPerfilOpt = true;
            Perfil.option(['order[descricao]=asc'].join("&"))
                .then(response => {
                    this.perfilOpt = response.data;
                })
                .finally(() => {
                    this.isLoadingPerfilOpt = false;
                });
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;
            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response) {
                        let err = error.response.data;
                        if (err.erros) {
                            for (let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    mounted() {
        this.loadPerfilOpt();
    }
}
</script>
